import React from 'react';
import classnames from 'classnames';

import { useComponentVisible } from '../helpers/hooks';

export default function Tooltip({ text }) {
  const {
    ref,
    isComponentVisible,
    setIsComponentVisible,
  } = useComponentVisible(false);

  return (
    <div className="tooltip-block--inline">
      <div
        ref={ref}
        className="tooltip__icon"
        onClick={() => {
          setIsComponentVisible(!isComponentVisible);
        }}
      />
      <div
        className={classnames('tooltip tooltip--down', {
          'tooltip--show': isComponentVisible,
        })}
      >
        {text}
      </div>
    </div>
  );
}
